import { render, staticRenderFns } from "./TrainersList.vue?vue&type=template&id=0f0ae853&scoped=true&"
import script from "./TrainersList.vue?vue&type=script&lang=js&"
export * from "./TrainersList.vue?vue&type=script&lang=js&"
import style0 from "./TrainersList.vue?vue&type=style&index=0&id=0f0ae853&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0ae853",
  null
  
)

export default component.exports